import Button from "../../components/buttons/button";
const AcceptRequest = ({ t, selected, setOpen }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-xl font-bold text-center">{t("acceptRequest")}</h3>
      <section className="space-y-1">
        <div className="p-3 space-y-4 border bg-sideBar border-primary rounded-xl">
          <p>
            <span className="font-medium text-mainGray">{t("member")}</span>
            <span className="font-semibold">{selected.fullName}</span>
          </p>
          <p>
            <span className="font-medium text-mainGray">{t("memberNumber")}</span>
            <span className="font-semibold">{selected.memberNumber}</span>
          </p>
          <p>
            <span className="font-medium text-mainGray">{t("requestType")}</span>
            <span className="font-semibold text-primary">اشتراك VIP</span>
          </p>
        </div>
        <p className="!my-4 font-medium text-mainGray">{t("doUAccept")}</p>
        <div className="flex items-center gap-4">
          <Button
            className={"bg-primary text-black"}
            type={"button"}
            onClick={() => setOpen(false)}
          >
            {t("accept")}
          </Button>
          <Button className="mainLinear" onClick={() => setOpen(false)}>
            {t("reject")}
          </Button>
        </div>
      </section>
    </div>
  );
};

export default AcceptRequest;
